import React from "react";
import Button from "react-bootstrap/Button";

function QtaSelector(props){
    return <div className="piatto-controlli">
        <div className="piatti-controlli-container">
            <Button variant={"light"} onClick={() => props.modificaQta(-1)}>-</Button>
            <span className="piatto-qta">{props.qta}</span>
            <Button variant={"light"} onClick={() => props.modificaQta(1)}>+</Button>
        </div>
    </div>;
}

export default QtaSelector;